import { ChangeEvent, KeyboardEvent } from 'react';

interface UseInputProps {
  onFocus?: (v: string) => void;
  onBlur?: (v: string) => void;
  onChange?: (v: string) => void;
  onKeyDown?: (v: string) => void;
  onKeyUp?: (v: string) => void;
  onKeyPress?: (v: string) => void;
}

export function useInput (props: UseInputProps) {
  const states = [
    'focused',
    'active',
    'hovered',
    'error',
    'static',
    'small',
    'medium',
    'large'
  ];

  const focus = (evt: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    if (props.onFocus) props.onFocus(evt.target.value);
  };

  const blur = (evt: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    if (props.onBlur) props.onBlur(evt.target.value);
  };

  const change = (evt: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    if (props.onChange) props.onChange(evt.target.value);
  };

  const keyPress = (evt: KeyboardEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    if (props.onKeyDown) props.onChange((evt.target as HTMLInputElement).value);
    else if (props.onKeyUp) props.onChange((evt.target as HTMLInputElement).value);
    else if (props.onKeyPress) props.onChange((evt.target as HTMLInputElement).value);
  };

  return {
    states,
    focus,
    blur,
    change,
    keyPress
  };
}
